(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function colores(root) {
    (root || document).querySelectorAll('[data-mt-colores]').forEach(function (box) {
      var opts = box.querySelectorAll('[data-mt-color]');
      var imgs = box.querySelectorAll('[data-mt-color-img]');
      var buy = box.querySelector('[data-mt-color-buy]');
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var id = opt.getAttribute('data-mt-color');
          opts.forEach(function (o) {
            o.classList.toggle('is-active', o === opt);
            o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
          });
          imgs.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-mt-color-img') === id);
          });
          if (buy && opt.dataset.url) buy.setAttribute('href', opt.dataset.url);
        });
      });
    });
  }

  function pack(root) {
    (root || document).querySelectorAll('[data-mt-pack]').forEach(function (box) {
      var btn = box.querySelector('[data-mt-pack-add]');
      var error = box.querySelector('[data-mt-pack-error]');
      if (!btn) return;
      var imgs = box.querySelectorAll('[data-mt-pack-img]');
      box.querySelectorAll('[data-mt-pack-select]').forEach(function (sel, i) {
        sel.addEventListener('change', function () {
          var src = sel.options[sel.selectedIndex].dataset.img;
          var img = imgs[i];
          if (!img || !src) return;
          img.classList.add('is-changing');
          setTimeout(function () { img.src = src; img.classList.remove('is-changing'); }, 250);
        });
      });
      btn.addEventListener('click', function () {
        var counts = {};
        box.querySelectorAll('[data-mt-pack-select]').forEach(function (sel) {
          counts[sel.value] = (counts[sel.value] || 0) + 1;
        });
        var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
        btn.disabled = true;
        if (error) error.hidden = true;
        fetch(box.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            window.location.href = box.dataset.cartUrl;
          })
          .catch(function () {
            btn.disabled = false;
            if (error) error.hidden = false;
          });
      });
    });
  }

  function init(root) { reveal(root); colores(root); pack(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
